import React from "react";
import { Typography, Descriptions, Input, Badge } from "antd";
import log from "../utils/log";
import moment from "moment-timezone";
import { formatTime } from "../utils/time";

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const RequestMeta = ({ request }) => {
  // Prepare the items for the Descriptions component
  const items = [
    {
      key: "create",
      label: "Create",
      children: request ? <Text>{formatTime(request.time.create)}</Text> : "none",
    },
    {
      key: "lastModify",
      label: "LastModify",
      children: request ? <Text>{formatTime(request.time.lastModify)}</Text> : "none",
    },
    {
      key: "approved",
      label: "Approved",
      children: request?.time?.approved ? <Text>{formatTime(request.time.approved)}</Text> : "none",
    },
    {
      key: "id",
      label: "Request ID",
      children: request?.id ? <Paragraph copyable>{request?.id}</Paragraph> : "none",
    },
    {
      key: "user",
      label: "User",
      children: request?.user?.email ? <Text>{request.user?.email}</Text> : "none",
    },
    {
      key: "approver",
      label: "Approver",
      children: request?.approver?.email ? <Text>{request.approver?.email}</Text> : "none",
    },
    {
      key: "remark",
      label: (
        <Badge dot={request?.remark} style={{ padding: "0.25rem" }} offset={[0, -5]}>
          <span style={{ color: "var(--ion-color-step-500)" }}>Remark</span>
        </Badge>
      ),
      children: request?.remark ? (
        <Paragraph
          style={{ width: "100%", whiteSpace: "pre-wrap" }}
          ellipsis={{
            rows: 2,
            expandable: true,
            symbol: "more",
          }}
        >
          {request.remark}
        </Paragraph>
      ) : (
        "none"
      ),
    },
  ];

  // Conditionally add the Shop ID item based on the presence of request?.info?.product
  if (!request?.info?.product) {
    items.push({
      key: "shopId",
      label: "Shop ID",
      children: request?.info?.shop?.id ? <Paragraph copyable>{request?.info?.shop?.id}</Paragraph> : "none",
    });
  }

  return (
    <Descriptions
      style={{
        margin: "3rem 2rem",
      }}
      size="large"
      items={items}
    />
  );
};

export default RequestMeta;
